<template>
  <div class="row details auction-house-details">
    <div class="details__info col-sm-12 mb-3">
      <p>
        <span>{{I18n.l("time.formats.full_date", auctionsCatalog.startDate)}}</span>,
        <span>{{I18n.l("date.formats.weekday", auctionsCatalog.startDate)}}</span>
        <span class="time">{{I18n.l("time.formats.time", auctionsCatalog.startDate)}}</span>
        <span>{{address.city}}</span>
      </p>
    </div>
    <div class="col-sm-auto details__thumb">
      <img alt="" :src="auctionHouse.logoThumbUrl" />
    </div>
    <div class="col-sm-8 details__name pl-0">
      <p class="short mb-0">{{auctionHouse.shortName}}</p>
      <p class="full">{{auctionsCatalog.name}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AuctionHouseDetails',
    props: {
      auctionsCatalog: Object,
      auctionHouse: Object,
      address: Object,
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/auction_house_details.vue?7b0eab20